import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Hero from '../../../components/commons/hero/hero.component';
import ContentWell from '../../../components/commons/content-well/content-well.component';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function SoftwareCategoryCommon({ page: { MainContent } }) {
  if (MainContent) {
    return (
      <div className="software-secondary software">
        <Hero
          src={MainContent.HeaderImage_src}
          mobileImgSrc={MainContent.MobileImage_src}
          alt={`${MainContent.Title} image`}
          template="featured"
          title={MainContent.Title}
          description={MainContent.HeaderContent}
          colorCategory="soft"
          altLayout
          specialityHeroCta
          specialityHeroCtaData={MainContent}
        />

        <div className="trinity-container sm-up-module-spacer">
          <Row>
            <Col className="content-container">
              <ContentWell content={MainContent.Content} />
            </Col>
            <Col className="d-lg-none inner-hero" />
          </Row>
        </div>
      </div>
    );
  }
  return <Loader />;
}

export default SoftwareCategoryCommon;
